import { assign } from 'lodash';
import { getters as baseGetters, GETTER_TYPES as BASE_GETTER_TYPES } from '../base-collection/getters';
import { STATE_KEYS } from './state';

const GETTER_TYPES = assign({}, BASE_GETTER_TYPES, {
  GET_FIRST_TIME_USER: 'getFirstTimeUser',
  GET_ONBOARDING_ITEMS: 'getOnboardingMenuItems',
  GET_STARTED_VIDEO_URL: 'getStartedVideoUrl',
});

const getters = assign({}, baseGetters, {
  [GETTER_TYPES.GET_FIRST_TIME_USER](state) {
    return state[STATE_KEYS.IS_FIRST_TIME_USER];
  },
  [GETTER_TYPES.GET_ONBOARDING_ITEMS](state) {
    return state[STATE_KEYS.ONBOARDING_ITEMS];
  },
  [GETTER_TYPES.GET_STARTED_VIDEO_URL](state) {
    return state[STATE_KEYS.STARTED_VIDEO_URL];
  },
});

export {
  getters,
  GETTER_TYPES,
};
